import * as React from "react";
import C from "classnames";
const expandMapper = {
    xs: "navbar-expand-xs",
    sm: "navbar-expand-sm",
    md: "navbar-expand-md",
    lg: "navbar-expand-lg",
    xl: "navbar-expand-xl",
};
const variantMapper = {
    light: "navbar-light",
    dark: "navbar-dark",
};
export const Nav = (props) => {
    return (React.createElement("nav", { id: props.id, className: C("navbar", props.className, props.variant ? variantMapper[props.variant] : "navbar-light", props.tabs && "nav-tabs", props.pills && "nav-pills", props.vertical && "navbar-vertical", props.fixed === "right"
            ? "fixed-right"
            : props.fixed === "left"
                ? "fixed-left"
                : props.fixed === "top"
                    ? "fixed-top"
                    : props.fixed === "bottom"
                        ? "fixed-bottom"
                        : "", props.relative && "position-relative", props.expand ? expandMapper[props.expand] : "navbar-expand-md", props.widthAuto && "w-auto"), "data-testid": props.testId }, props.vertical ? (React.createElement("div", { className: "nav-padding py-6" }, props.children)) : (React.createElement(React.Fragment, null, props.children))));
};
//# sourceMappingURL=Nav.js.map